export class Parametre {
  nom
  type
  reference
  referenceObj = null
  description

  constructor(nom = '', type = null, reference = null, description = '') {
    this.nom = nom
    this.type = type
    this.reference = reference
    this.description = description
  }

  static NULL = new Parametre()
}
